"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _Action = _interopRequireDefault(require("./Action"));

var _Input = _interopRequireDefault(require("./Input"));

var _Item = _interopRequireDefault(require("./Item"));

var _Label = _interopRequireDefault(require("./Label"));

var _Link = _interopRequireDefault(require("./Link"));

var _Nav = _interopRequireDefault(require("./Nav"));

var _Section = _interopRequireDefault(require("./Section"));

var _excluded = ["children", "className", "inlineBreakpoint", "light", "subnav"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ClayToolbar(_ref) {
  var _ref2;

  var children = _ref.children,
      className = _ref.className,
      inlineBreakpoint = _ref.inlineBreakpoint,
      light = _ref.light,
      subnav = _ref.subnav,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  subnav = subnav === true ? {} : subnav;
  var classes = (0, _classnames.default)(className, 'tbar', {
    'component-tbar': !subnav,
    'subnav-tbar': !!subnav,
    'tbar-light': light
  }, subnav && (_ref2 = {
    'subnav-tbar-disabled': subnav.disabled
  }, _defineProperty(_ref2, "tbar-inline-".concat(inlineBreakpoint, "-down"), inlineBreakpoint), _defineProperty(_ref2, "subnav-tbar-".concat(subnav.displayType), subnav.displayType), _ref2));
  return /*#__PURE__*/_react.default.createElement("nav", _extends({}, otherProps, {
    className: classes
  }), children);
}

ClayToolbar.Action = _Action.default;
ClayToolbar.Item = _Item.default;
ClayToolbar.Input = _Input.default;
ClayToolbar.Label = _Label.default;
ClayToolbar.Link = _Link.default;
ClayToolbar.Nav = _Nav.default;
ClayToolbar.Section = _Section.default;
var _default = ClayToolbar;
exports.default = _default;